import React, { HTMLAttributes } from "react";
import cx from "clsx";
import { CommonComponentProps } from "./componentTypes";
import { cleanHtmlRestProps } from "@/lib/utils";

interface H4Props
  extends HTMLAttributes<HTMLHeadingElement>,
    CommonComponentProps {}

export function H4({ children, className, ...rest }: H4Props) {
  return (
    <h4
      className={cx(
        "font-sans text-base font-bold leading-[1.2] text-foreground",
        className
      )}
      {...cleanHtmlRestProps(rest)}
    >
      {children}
    </h4>
  );
}
